import { getPreviousMonthFromTo } from "@/core/lib/utils";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { format } from "date-fns";
import { z } from "zod";

const { from, to } = getPreviousMonthFromTo();

const reservationsSearchSchema = z.object({
	page: z.number().catch(1),
	pageSize: z.number().catch(10),
	sortBy: z
		.enum([
			"bookingDate",
			"status",
			"purchaseId",
			"guestName",
			"country",
			"rooms",
			"activitiesProducts",
			"packages",
			"totalAmount",
			"taxes",
			"totalCost",
			"balance",
			"checkInDate",
		])
		.catch("bookingDate"),
	orderBy: z.enum(["asc", "desc"]).catch("asc"),
	source: z.enum(["All", "Web", "Mews"]).catch("Web"),
	purchaseId: z.string().catch(""),
	guestName: z.string().catch(""),
	// Optional (like checkInFrom/To) so pre-existing navigations into this
	// route don't have to spell them out.
	promoCode: z.string().optional().catch(undefined),
	// Agents.id — the filters modal resolves agentNumber -> id in its select
	// (agentNumber alone is ambiguous: unique only per (reseller, type)).
	agentId: z.string().optional().catch(undefined),
	status: z.enum(["Confirmed", "Cancelled", "Completed"]).optional().catch(undefined),
	dateMode: z.enum(["booking", "checkIn", "all"]).catch("booking"),
	fromDate: z.string().catch(format(from, "yyyy-MM-dd")),
	endDate: z.string().catch(format(to, "yyyy-MM-dd")),
	checkInFrom: z.string().optional().catch(undefined),
	checkInTo: z.string().optional().catch(undefined),
});

export const Route = createFileRoute(
	"/_layout/dashboard/sites/$siteId/reservations/",
)({
	validateSearch: (search) => reservationsSearchSchema.parse(search),
	beforeLoad: ({ context: { auth } }) => {
		if (auth.isExpired()) {
			return;
		}
		if (!auth.isAuthenticated) {
			throw redirect({
				to: "/",
			});
		}
	},
});
